"use client"

import { NavigateWithThread } from '@yeshuman/sdk'
import { useParams } from 'react-router-dom'

/**
 * Legacy `/candidate/applications/:applicationId` URL (bookmarks, old notification links).
 * Applied is now a status-first surface on Jobs — redirect into the Applied tab and let
 * `CandidateJobsPage` open the status canvas via the `application` deep-link param.
 */
export function ApplicationDetailPage() {
  const { applicationId } = useParams<{ applicationId: string }>()

  const target = applicationId
    ? `/candidate/jobs?tab=applied&application=${encodeURIComponent(applicationId)}`
    : '/candidate/jobs?tab=applied'

  return <NavigateWithThread to={target} />
}
